import routes from '../consts/routes';
import sessionManagementTypes from '../consts/sessionManagementTypes';
import AuthSessionAccessError from '../errors/authSessionAccessError';
import InactiveSessionError from '../errors/inactiveSessionError';
import {selectIsSessionValidationInProgress} from '../state/selectors/session';
import {setIsSessionValidationInProgress} from '../state/slice/session';
import {dispatch, getState} from '../state/store';
import awsAuthService from './aws/awsAuthService';
import iapClientService from './iap/iapClientService';
import localhostService from './localhostService';
import log from './logger/log';

const DISABLED_PAGES_FOR_SESSION_VALIDATION = [
    routes.DEVICE_REGISTRATION,
    routes.DEVICE_REGISTRATION_ERROR,
    routes.DEVICE_CONNECTION,
    routes.DEVICE_CONNECTION_ERROR,
];

const createUserSession = async (refreshToken) => {
    try {
        if (localhostService.getShouldSkipIapRequestsOnLocalhost()) return;

        await iapClientService.postCreateSession(refreshToken);
    } catch (e) {
        throw new AuthSessionAccessError(`Failed to create user session: ${e.message}`);
    }
};

const validateUserSession = async () => {
    try {
        const isDisabled = DISABLED_PAGES_FOR_SESSION_VALIDATION.includes(window.location.pathname);
        const isSessionValidationInProgress = selectIsSessionValidationInProgress(getState());

        if (isDisabled || localhostService.getShouldSkipIapRequestsOnLocalhost()) {
            log.info('userSessionManagementService: Skipping session validation on the current page.');
            return;
        }

        if (isSessionValidationInProgress) {
            log.info('userSessionManagementService: Session validation is already in progress.');
            return;
        }

        dispatch(setIsSessionValidationInProgress(true));

        const {state} = (await iapClientService.getCurrentSession()) || {};

        if (state === sessionManagementTypes.ACTIVE) return;

        log.error('userSessionManagementService: User session is not active, signing out.');

        await awsAuthService.handleAuthenticationError(new InactiveSessionError());
    } catch (e) {
        log.error('userSessionManagementService: Failed to check user session status.', e.message);
    } finally {
        dispatch(setIsSessionValidationInProgress(false));
    }
};

export default {
    createUserSession,
    validateUserSession,
};
